import type { ScaleLinear } from 'd3-scale';
import { animated } from 'react-spring';
import { useMentiSpring } from '@mentimeter/motion/spring';

interface ScalesOverallAverageProps {
  color: string;
  overallAverage: number;
  textColor: string;
  xScale: ScaleLinear<number, number>;
  height: number;
  disableAnimations?: boolean;
}

const CIRCLE_RADIUS = 30;

export const ScalesOverallAverage = ({
  color,
  xScale,
  overallAverage,
  height,
  textColor,
  disableAnimations = false,
}: ScalesOverallAverageProps) => {
  const [{ transform }] = useMentiSpring({
    from: { transform: `translate(${xScale(0)}px)` },
    to: {
      transform: `translate(${xScale(overallAverage)}px)`,
    },
    immediate: disableAnimations,
  });

  const circleY = height + CIRCLE_RADIUS;

  return (
    <animated.g data-testid="overall-average" style={{ transform }}>
      <animated.line y1={0} y2={circleY} stroke={color} strokeWidth={2} />
      <animated.circle
        cy={circleY}
        r={CIRCLE_RADIUS}
        fill={color}
        stroke="none"
      />
      <animated.text
        fill={textColor}
        y={circleY}
        fontSize={CIRCLE_RADIUS * 0.7}
        textAnchor="middle"
        dominantBaseline="middle"
      >
        {overallAverage.toFixed(1)}
      </animated.text>
    </animated.g>
  );
};
